import React, { useState } from 'react';
import API from '../utils/api';

export default function GrandparentShareModal({ storyId, storyTitle, onClose }) {
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [message, setMessage] = useState('');
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const handleSend = async (e) => {
    e.preventDefault();
    setError('');
    setSending(true);
    try {
      await API.post('/grandparent/notify', {
        storyId,
        grandparentEmail: email,
        grandparentName: name,
        message,
      });
      setSent(true);
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to send. Try again.');
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="modal show d-block" style={{ background: 'rgba(0,0,0,0.55)', zIndex: 1060 }}
      onClick={e => { if (e.target === e.currentTarget) onClose(); }}>
      <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: 420 }}>
        <div className="modal-content border-0 rounded-4">
          <div className="modal-header border-0 px-4 pt-4 pb-2">
            <div>
              <h5 className="modal-title fw-bold mb-0" style={{ color: 'var(--text-main)', fontFamily: "'Fredoka One',cursive" }}>
                👴 Share with Grandparents
              </h5>
              <p className="text-muted small mb-0 mt-1">Send tonight's story to someone special</p>
            </div>
            <button className="btn-close ms-auto" onClick={onClose}></button>
          </div>

          <div className="modal-body px-4 pb-4">
            {sent ? (
              <div className="text-center py-3">
                <div style={{ fontSize: '56px', marginBottom: '12px' }}>💌</div>
                <h6 className="fw-bold" style={{ color: 'var(--text-main)' }}>Story sent!</h6>
                <p className="text-muted small">{name || 'They'} will receive an email with the full story.</p>
                <button className="btn btn-dream rounded-pill px-4 mt-2" onClick={onClose}>Done</button>
              </div>
            ) : (
              <form onSubmit={handleSend}>
                <div className="p-3 rounded-3 mb-3" style={{ background: 'var(--purple-section)', border: '1px solid var(--border-purple)' }}>
                  <div className="fw-semibold small" style={{ color: '#6f42c1' }}>📖 {storyTitle}</div>
                </div>

                {error && <div className="alert alert-danger py-2 small rounded-3 mb-3">{error}</div>}

                <div className="mb-3">
                  <label className="form-label fw-semibold small" style={{ color: 'var(--text-main)' }}>Their Name</label>
                  <input className="form-control" placeholder="e.g. Grandma Rose" maxLength={50}
                    value={name} onChange={e => setName(e.target.value)} />
                </div>

                <div className="mb-3">
                  <label className="form-label fw-semibold small" style={{ color: 'var(--text-main)' }}>Email Address <span className="text-danger">*</span></label>
                  <input className="form-control" type="email" placeholder="grandma@email.com" required
                    value={email} onChange={e => setEmail(e.target.value)} />
                </div>

                <div className="mb-4">
                  <label className="form-label fw-semibold small" style={{ color: 'var(--text-main)' }}>Personal Message <span className="text-muted fw-normal">(optional)</span></label>
                  <textarea className="form-control" rows={2} maxLength={200}
                    placeholder="We thought of you while reading this tonight…"
                    value={message} onChange={e => setMessage(e.target.value)} />
                </div>

                <div className="d-flex gap-2">
                  <button type="button" className="btn btn-outline-secondary rounded-pill flex-grow-1" onClick={onClose}>Cancel</button>
                  <button type="submit" className="btn btn-dream rounded-pill flex-grow-1 fw-semibold" disabled={sending}>
                    {sending ? <><span className="spinner-border spinner-border-sm me-2"></span>Sending…</> : '💌 Send Story'}
                  </button>
                </div>
              </form>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
